export const styles = (theme) => ({
  root: {
    height: '100%',
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  content: {
    maxWidth: 640,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  image: {
    width: 120,
    height: 120,
  },
  title: {
    fontSize: 20,
    fontWeight: theme.typography.fontWeightMedium,
  },
  body: {
    fontSize: 18,
    color: theme.palette.text.secondary,
  },
  entityName: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});
